/* Omorfia v2 — küçük ortak davranışlar */

// Carousel okları: <button data-om-scroll="prev|next" data-om-target="#id">
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-om-scroll]');
  if (!button) return;
  const track = document.querySelector(button.dataset.omTarget);
  if (!track) return;
  const item = track.firstElementChild;
  const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
  const step = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
  track.scrollBy({ left: button.dataset.omScroll === 'next' ? step : -step, behavior: 'smooth' });
});

function omUpdateArrows(track) {
  document.querySelectorAll(`[data-om-target="#${track.id}"]`).forEach((button) => {
    const atStart = track.scrollLeft <= 2;
    const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    button.disabled = button.dataset.omScroll === 'prev' ? atStart : atEnd;
  });
}

function omInitScrollers(root = document) {
  root.querySelectorAll('.om-scroller[id]').forEach((track) => {
    if (track.dataset.omReady) return;
    track.dataset.omReady = 'true';
    track.addEventListener('scroll', () => omUpdateArrows(track), { passive: true });
    window.addEventListener('resize', () => omUpdateArrows(track));
    omUpdateArrows(track);
  });
}

document.addEventListener('DOMContentLoaded', () => omInitScrollers());
document.addEventListener('shopify:section:load', (event) => omInitScrollers(event.target));

// Hero slider
class OmSlider extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-om-slide]')];
    this.counter = this.querySelector('[data-om-counter]');
    this.pauseButton = this.querySelector('[data-om-pause]');
    this.index = 0;
    this.interval = parseInt(this.dataset.speed || '0', 10) * 1000;
    this.paused = false;
    this.querySelector('[data-om-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
    this.querySelector('[data-om-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
    this.pauseButton?.addEventListener('click', () => this.togglePause());
    this.show(0);
    this.start();
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  show(index) {
    this.slides.forEach((slide, i) => {
      const active = i === index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', !active);
      slide.querySelectorAll('a, button').forEach((el) => (el.tabIndex = active ? 0 : -1));
    });
    if (this.counter) this.counter.textContent = `${index + 1} / ${this.slides.length}`;
  }

  go(index, manual) {
    if (this.slides.length < 2) return;
    this.index = (index + this.slides.length) % this.slides.length;
    this.show(this.index);
    if (manual) this.start();
  }

  start() {
    clearInterval(this.timer);
    if (!this.interval || this.paused || this.slides.length < 2) return;
    this.timer = setInterval(() => this.go(this.index + 1), this.interval);
  }

  togglePause() {
    this.paused = !this.paused;
    this.pauseButton.classList.toggle('is-paused', this.paused);
    this.pauseButton.setAttribute('aria-label', this.paused ? 'Oynat' : 'Duraklat');
    this.paused ? clearInterval(this.timer) : this.start();
  }
}
if (!customElements.get('om-slider')) customElements.define('om-slider', OmSlider);

// Sepet çekmecesi: promosyon kodu uygula + sözleşme onayı
document.addEventListener('click', async (event) => {
  const apply = event.target.closest('[data-om-promo-apply]');
  if (apply) {
    const row = apply.closest('[data-om-promo]');
    const input = row.querySelector('input');
    const msg = row.parentElement.querySelector('[data-om-promo-msg]');
    const code = input.value.trim();
    if (!code) { input.focus(); return; }
    apply.disabled = true;
    try {
      await fetch(`${window.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code }),
      });
      const cart = await (await fetch(`${window.routes.cart_url}.js`)).json();
      const ok = (cart.discount_codes || []).some((d) => d.code.toLowerCase() === code.toLowerCase() && d.applicable);
      const drawer = document.querySelector('cart-drawer');
      const sections = await (await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`)).json();
      if (drawer && drawer.renderContents) drawer.renderContents({ sections });
      const newMsg = document.querySelector('[data-om-promo-msg]');
      const details = document.querySelector('.om-cartx__promo');
      if (details) details.open = true;
      if (newMsg) newMsg.textContent = ok ? 'Kod uygulandı.' : 'Bu kod geçerli değil veya sepetinize uygulanamıyor.';
    } catch (e) {
      if (msg) msg.textContent = 'Kod uygulanamadı, lütfen tekrar deneyin.';
    } finally {
      apply.disabled = false;
    }
    return;
  }

  const checkout = event.target.closest('#CartDrawer-Checkout, #checkout, button[name="checkout"]');
  if (checkout) {
    const scope = checkout.closest('cart-drawer, form, .cart__footer, .cart__blocks') || document;
    const terms = scope.querySelector('[data-om-cart-terms]') || document.querySelector('[data-om-cart-terms]');
    if (terms && terms.dataset.required === 'true' && !terms.checked) {
      event.preventDefault();
      event.stopPropagation();
      const label = terms.closest('.om-cart-terms');
      const err = label.parentElement.querySelector('[data-om-cart-terms-error]');
      label.classList.add('is-error');
      if (err) err.hidden = false;
      terms.focus();
      setTimeout(() => label.classList.remove('is-error'), 2500);
    }
  }
});

// Onay seçimini oturum boyunca hatırla (çekmece yeniden çizildiğinde kaybolmasın)
function omRestoreTerms(root = document) {
  let saved = false;
  try { saved = sessionStorage.getItem('om-terms') === '1'; } catch (e) {}
  root.querySelectorAll('[data-om-cart-terms]').forEach((cb) => { if (saved) cb.checked = true; });
}
document.addEventListener('change', (event) => {
  const cb = event.target.closest('[data-om-cart-terms]');
  if (!cb) return;
  try { sessionStorage.setItem('om-terms', cb.checked ? '1' : '0'); } catch (e) {}
  document.querySelectorAll('[data-om-cart-terms]').forEach((other) => { other.checked = cb.checked; });
  const err = cb.closest('.om-cart-terms').parentElement.querySelector('[data-om-cart-terms-error]');
  if (err && cb.checked) err.hidden = true;
});
document.addEventListener('DOMContentLoaded', () => omRestoreTerms());
new MutationObserver(() => omRestoreTerms()).observe(document.documentElement, { childList: true, subtree: true });

/* Judge.me yorumcu adı: "Ayşe Yılmaz" → "Ayşe Y." (kurucu kararı 2026-09-25; Judge.me ayarından bağımsız) */
(function () {
  var up = function (c) { return c === 'i' ? 'İ' : c === 'ı' ? 'I' : c.toLocaleUpperCase('tr-TR'); };
  var shorten = function (el) {
    var t = el.textContent.trim();
    var parts = t.split(/\s+/);
    if (parts.length < 2 || /^\S\.$/.test(parts[parts.length - 1])) return;
    var out = parts.slice(0, -1).join(' ') + ' ' + up(parts[parts.length - 1].charAt(0)) + '.';
    if (out !== t) { el.textContent = out; el.setAttribute('title', out); }
  };
  /* ikas'tan aktarılan metinsiz (yalnızca puan) değerlendirmeler ortalamaya sayılır ama listede gösterilmez
     (kurucu kararı 2026-09-25). Bu kayıtlar Judge.me'de en eski tarihli; listenin sonunda kalırlar. */
  var hidePlaceholder = function (el) {
    if (el.textContent.trim() !== 'Yalnızca puan verildi.') return;
    var item = el.closest('.jm-review-item') || el;
    item.style.display = 'none';
  };
  var run = function (root) {
    root = root || document;
    root.querySelectorAll('.jm-reviewer-info__name').forEach(shorten);
    root.querySelectorAll('.jm-review-body-wrapper').forEach(hidePlaceholder);
  };
  var start = function () {
    var host = document.getElementById('judgeme_product_reviews') || document.body;
    run(host);
    new MutationObserver(function () { run(host); }).observe(host, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/* Hediye ürün: hediye hariç sepet tutarı eşiği geçince hediyeyi (_gift) ekle, altına düşünce çıkar.
   Ücretsizlik Shopify otomatik "X al Y kazan" indirimiyle sağlanır. */
let omGiftBusy = false;
async function omGiftSync() {
  const el = document.querySelector('[data-om-gift]');
  if (!el || omGiftBusy) return;
  omGiftBusy = true;
  try {
    const cart = await (await fetch(`${window.routes.cart_url}.js`)).json();
    const threshold = Number(el.dataset.threshold);
    const variant = Number(el.dataset.variant);
    const giftLine = cart.items.find((i) => i.properties && i.properties._gift);
    const subtotal = cart.items.filter((i) => !(i.properties && i.properties._gift) && i.product_type !== 'Hediye').reduce((s, i) => s + i.final_line_price, 0);
    let body = null;
    if (subtotal >= threshold && cart.item_count > 0 && !giftLine) {
      await fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variant, quantity: 1, properties: { _gift: 'Hediye' } }] }),
      });
      body = true;
    } else if (giftLine && (subtotal < threshold || giftLine.quantity !== 1)) {
      body = { id: giftLine.key, quantity: subtotal < threshold ? 0 : 1 };
      await fetch(`${window.routes.cart_change_url}.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body),
      });
    }
    if (body) {
      if (window.location.pathname === window.routes.cart_url) { window.location.reload(); return; }
      const drawer = document.querySelector('cart-drawer');
      const sections = await (await fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`)).json();
      if (drawer && drawer.classList.contains('active') && drawer.renderContents) {
        drawer.renderContents({ sections });
      } else {
        const swap = (html, freshSel, curSel) => {
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(freshSel);
          const cur = document.querySelector(curSel);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        };
        swap(sections['cart-drawer'], '#CartDrawer', '#CartDrawer');
        swap(sections['cart-icon-bubble'], '.shopify-section', '#cart-icon-bubble');
      }
    }
  } catch (e) { /* hediye senkronu başarısızsa sepet normal çalışmaya devam eder */ }
  omGiftBusy = false;
}
document.addEventListener('DOMContentLoaded', () => {
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, () => setTimeout(omGiftSync, 50));
  omGiftSync();
});

/* Videolar: tarayıcılar sesli otomatik oynatmaya izin vermediği için videolar sessiz yüklenir.
   Müşteri oynat'a bastığında (kullanıcı hareketi) ses açılır; sağ üstte ses aç/kapat butonu çıkar.
   Aynı anda tek video sesli oynar. */
window.omStopVideo = (video, holder) => {
  video.pause();
  holder.classList.remove('is-playing');
};
window.omPlayWithSound = (video, holder) => {
  document.querySelectorAll('video').forEach((v) => {
    if (v !== video && !v.paused) {
      const h = v.closest('.om-ugc__item, .om-vp__card');
      if (h) window.omStopVideo(v, h);
    }
  });
  video.muted = false;
  video.volume = 1;
  const p = video.play();
  if (p && p.catch) p.catch(() => { video.muted = true; video.play(); omSyncSound(holder, video); });
  holder.classList.add('is-playing');
  omSyncSound(holder, video);
};
function omSyncSound(holder, video) {
  const btn = holder.querySelector('[data-om-sound]');
  if (!btn) return;
  btn.hidden = false;
  btn.classList.toggle('is-muted', video.muted);
  btn.setAttribute('aria-label', video.muted ? 'Sesi aç' : 'Sesi kapat');
}
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-om-sound]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  const holder = btn.closest('.om-ugc__item, .om-vp__card');
  const video = holder && holder.querySelector('video');
  if (!video) return;
  video.muted = !video.muted;
  omSyncSound(holder, video);
});
